export default __webpack_public_path__ + "svg/map/Ciudades-icex-2027.svg?a23ffa0f";